import { CircleHelp } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { hasTabHelp, helpByKey, helpFor } from '@/lib/help/help-resolve';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';
import { useHelp } from './HelpProvider';

export function HelpButton({ topicKey, tab, className }: { topicKey?: string; tab?: string; className?: string }) {
  const help = useHelp();
  const { pathname } = useLocation();
  if (!help) return null;
  const available = topicKey ? Boolean(helpByKey(topicKey)) : tab ? hasTabHelp(pathname, tab) : Boolean(helpFor(pathname));
  if (!available) return null;
  const label = tab ? 'Help for this tab' : 'Help for this screen';
  return (
    <Tooltip content={`${label} (?)`}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label={label}
        className={cn('h-8 w-8 text-muted-foreground hover:text-foreground', className)}
        onClick={() => help.open(topicKey ? { key: topicKey } : tab ? { tab } : {})}
      >
        <CircleHelp className="h-4 w-4" aria-hidden />
      </Button>
    </Tooltip>
  );
}
